/* eslint-disable @typescript-eslint/no-non-null-assertion */
/* eslint-disable no-nested-ternary */
/* eslint-disable import/no-cycle */
/* eslint-disable @typescript-eslint/naming-convention */
import MUISelectInput from '@brands/Components/Inputs/MuiSelectInput/MUISelectInput';
import MultiSelectInputMUI from '@brands/Components/Inputs/MuiMultiSelectInput/MultiSelectInputMUI';
import MuiTextField from '@brands/Components/Inputs/MuiTextField/TextField';
import MuiPhoneInput from '@brands/Components/Inputs/MuiTelInput/MuiTelInput';
import SecondaryInsuranceFields from '@brands/Dashboard/Dashboard/Components/InsuranceFields/SecondaryInsuranceFields';
import AddressSection from '@brands/Dashboard/Dashboard/SuperAdmin/Components/AddressSection/AddressSection';
import { stateFundedProgramOptions } from '@brands/Dashboard/PatientForms/PatientForm/utils/types';
import { useInsuranceCarriers } from '@brands/hooks';
import { useAppDispatch, useAppSelector } from '@brands/hooks/useReduxHook';
import useRoleNavigate from '@brands/hooks/useRoleNavigate';
import { CaseType } from '@brands/services/cases/types/ICase';
import { createPatientInsurance } from '@brands/services/identity/createPatientInsurance';
import { getPatientInsurance } from '@brands/services/identity/getPatientInsurance';
import { Pricings } from '@brands/services/identity/getPricings';
import { getUserById } from '@brands/services/identity/getUserById';
import { UpdateMe, updateMe } from '@brands/services/identity/updateMe';
import { selectAuth } from '@brands/store/selectors/auth';
import { selectOrganization } from '@brands/store/selectors/organization';
import { selectOrganizationPrices } from '@brands/store/selectors/organizationPrices';
import { selectPageState } from '@brands/store/selectors/pageState';
import { selectPatientForm } from '@brands/store/selectors/patientForm';
import { selectPatient } from '@brands/store/selectors/selectedPatient';
import { addDependent, updateDependent as editDependent } from '@brands/store/slices/dependentsSlice';
import { setDependentId, setIsFromSelectPatient } from '@brands/store/slices/pageStateSlice';
import { setStaffIntakeInProgress } from '@brands/store/slices/staffCaseCreationSlice';
import { setExternalForms, setSelectedPatient } from '@brands/store/slices/patientFormSlice';
import { setSelectedPatientByAdmin } from '@brands/store/slices/selectedPatientSlice';
import { dateAutoSlashes } from '@brands/Utils/checkAndSetDate';
import { checkExternalFormAnswers } from '@brands/Utils/checkExternalForms';
import { displayErrorDetails } from '@brands/Utils/displayError';
import {
  getStaffReviewProfileBasePath,
  isStaffCaseCreationRole,
  isUnifiedStaffCaseIntakeRole,
} from '@brands/Utils/reviewProfileBasePath';
import { isFree, needsPayment } from '@brands/Utils/needsPayment';
import { UnifiedProfileSubmit } from '@brands/Utils/types';
import { validateAddress, ValidationModalInterface } from '@brands/Utils/validateAddress';
import { yupResolver } from '@hookform/resolvers/yup';

import { E164Number, isValidPhoneNumber, parsePhoneNumber } from 'libphonenumber-js';
import { isEqual } from 'lodash';
import moment from 'moment';
import React, { useEffect, useMemo, useRef, useState } from 'react';
import { useForm, UseFormGetValues } from 'react-hook-form';
import { MdKeyboardArrowLeft } from 'react-icons/md';
import { useNavigate } from 'react-router-dom';
import { MultiValue } from 'react-select';
import { toast } from 'react-toastify';
import { Box, Checkbox, Divider, FormControlLabel, Button as MuiButton, Typography } from '@mui/material';

import Button from '../../../../../Components/Button/Button';
import ConfirmationModal from '../../../../../Components/Modals/ConfirmationModal/ConfirmationModal';
import ProfileImage from '../../../../../Components/ProfileImage/ProfileImage';
import { RegisterMediaPayload } from '../../../../../services/communication/registersConversationMedia';
import { confirmAvatarMedia } from '../../../../../services/identity/confirmAvatarMedia';
import { createBasicInformation } from '../../../../../services/identity/createBasicInformation';
import { createDependent } from '../../../../../services/identity/createDependent';
import { deleteAvatar } from '../../../../../services/identity/deleteAvatar';
import { deleteDependent } from '../../../../../services/identity/deleteDependent';
import { getDependentById } from '../../../../../services/identity/getDependentById';
import { registerAvatarMedia } from '../../../../../services/identity/registerAvatarMedia';
import { saveBasicInformation } from '../../../../../services/identity/saveBasicInformation';
import { Dependent } from '../../../../../services/identity/types/Dependent';
import {
  Address,
  BasicInfo,
  Insurance,
  Marker,
  UserProfile,
  UserRoleName,
} from '../../../../../services/identity/types/UserProfile';
import { updateDependent } from '../../../../../services/identity/updateDependent';
import { updateAdminUser } from '../../../../../services/identity/updateAdminUser';
import { checkAndSetDate } from '../../../../../Utils/checkAndSetDate';
import { genderIdentity, genderOptions, pronounsOptions } from '../../../../../Utils/selectButtonOptions';
import { insuranceThroughOptions, OptionLanguage, stateOptions } from '../../../../../Utils/selectOptions';
import { areArraysEqual, updateDataInsurance, updateDataSecondaryInsurance } from '../../utils/utilsFunctions';
import { dependentAddValidationSchema, dependentUpdateValidationSchema } from '../../utils/validationSchema';
import EditInsurance from '../Insurance/EditInsurance';
import ReadOnlyInsurance from '../Insurance/ReadOnlyInsurance';
import styles from './styles.module.scss';
import addNewUserStyles from '../../../../Dashboard/Collector/AddNewUser/addNewUser.module.scss';
import collectorStyles from '../../../../Dashboard/Collector/EditUser/collectorEditUser.module.scss';
import { updateVerifiedEmail } from '@brands/services/identity/updateUserEmail';

export type DependentSubmit = {
  profile_img: string | null;
  first_name: string;
  middle_name: string;
  preferred_name: string;
  last_name: string;
  email: string;
  phone_number: string;
  zip_code: string;
  state: string;
  date_of_birth: string;
  pronouns: string;
  gender: string;
  gender_identity: string;
  address1: string;
  address2: string;
  city: string;
  country: string;
  profileAddress: string;
  profileCity: string;
  language: MultiValue<OptionLanguage>;
  id: number;
  patientId: number;
  guardian_relationship: string;
  dependent_email: string;
  member_id: string;
  group_number?: string;
  insurance_through: string;
  insurance_carrier_id?: number;
  state_funded_coverage_status?: string;
  is_secondary?: boolean;
  secondary_group_number?: string;
  secondary_member_id: string;
  secondary_iPhoneNumber: string;
  secondary_insurance_through: string;
  secondary_insurance_carrier_id?: number;
  insurance_address?: string;
  insurance_city?: string;
  insurance_state?: string;
  insurance_zip_code?: string;
  iFirstName: string;
  iMiddleName: string;
  iDateOfBirth: string;
  iGenderIdentity: string;
  iLastName: string;
  iAddress1: string;
  iAddress2: string;
  iZipCode: string;
  iState: string;
  iCity: string;
  secondary_iFirstName: string;
  secondary_iMiddleName: string;
  secondary_iDateOfBirth: string;
  secondary_iGenderIdentity: string;
  secondary_iLastName: string;
  secondary_iAddress1: string;
  secondary_iAddress2: string;
  secondary_iZipCode: string;
  secondary_iState: string;
  secondary_iCity: string;
  secondary_insurance_address: string;
  secondary_insurance_city: string;
  secondary_insurance_state: string;
  secondary_insurance_zip_code: string;
  iPhoneNumber: string;
  markers: Marker[];
};

type EditDependentProps = {
  setIsEditDependent: React.Dispatch<React.SetStateAction<boolean>>;
  setSelection: React.Dispatch<React.SetStateAction<[number | null, number | null] | null>>;
  setThisUser: React.Dispatch<React.SetStateAction<UserProfile>>;
  dependentId?: number | undefined;
  languageOptions: OptionLanguage[];
  isModal?: boolean;
  reviewProfile?: boolean;
  validationResponseId: string;
  setValidationResponseId: React.Dispatch<React.SetStateAction<string>>;
  isFromSelectNeeds: boolean | undefined;
  showDeleteDependentConfirmationModal?: boolean;
  setShowDeleteDependentConfirmationModal?: React.Dispatch<React.SetStateAction<boolean>>;
  roleName: string;
  externalAvatarPayload?: RegisterMediaPayload | null;
  externalAvatarFile?: File | null;
  externalAvatarAction?: string;
  onSaveSuccess?: () => void;
  onExternalAvatarSaved?: () => void;
  formRef?: React.RefObject<HTMLFormElement>;
  setIsDirty?: (dirty: boolean) => void;
};

export const relationshipOptions = [
  { value: 'parent', label: 'Parent' },
  { value: 'stepparent', label: 'Stepparent' },
  { value: 'sibling', label: 'Sibling' },
  { value: 'aunt_uncle', label: 'Aunt/Uncle' },
  { value: 'grandparent', label: 'Grandparent' },
  { value: 'appointed_guardian', label: 'Appointed Guardian' },
  { value: 'other', label: 'Other' },
];

const EditDependent = ({
  setIsEditDependent,
  setSelection,
  setThisUser,
  dependentId,
  languageOptions,
  isModal,
  reviewProfile,
  validationResponseId,
  setValidationResponseId,
  isFromSelectNeeds,
  showDeleteDependentConfirmationModal,
  setShowDeleteDependentConfirmationModal,
  roleName,
  externalAvatarPayload,
  externalAvatarFile,
  externalAvatarAction,
  onSaveSuccess,
  onExternalAvatarSaved,
  formRef,
  setIsDirty,
}: EditDependentProps): JSX.Element => {
  const dispatch = useAppDispatch();
  const { selectedPatient } = useAppSelector(selectPatient);
  const hasFetchedDependentRef = useRef(false);
  const hasFetchedGuardianRef = useRef(false);
  const { values } = useAppSelector(selectPatientForm);
  const [avatarPayload, setAvatarPayload] = useState<RegisterMediaPayload | null>(null);
  const { userInfo } = useAppSelector(selectAuth);
  const [fetchLoading, setFetchLoading] = useState(false);
  const { currentOrganization } = useAppSelector(selectOrganization);
  const organizationPrices = useAppSelector(selectOrganizationPrices);
  const { isFromSelectPatient, isEditInsuranceFlag } = useAppSelector(selectPageState);
  const [guardianPatient, setGuardianPatient] = useState<UserProfile>();
  const [avatarFile, setAvatarFile] = useState<File | null>(null);
  const [isSavingProfile, setIsSavingProfile] = useState(false);
  const [image, setImage] = useState<string | undefined>(undefined);
  const [avatarAction, setAvatarAction] = useState<string>('');
  const [patientInsurance, setPatientInsurance] = useState<Insurance[]>([]);
  const [isEditInsurance, setIsEditInsurance] = useState(false);
  const [addSecondaryInsurance, setAddSecondaryInsurance] = useState(patientInsurance.length > 1);
  const navigate = useNavigate();
  const roleNavigate = useRoleNavigate();
  const [key, setKey] = useState(0);
  const [isSelected, setIsSelected] = React.useState<number | null>(null);
  const isHydratingFormRef = useRef(false);
  const hasUserEditedFormRef = useRef(false);
  // Server-side phone/email of the dependent being edited, captured at fetch
  // time. Redux `selectedPatient` can hold a different record (new-dependent
  // path, stale selection), so clear-detection must not rely on it.
  const savedDependentRef = useRef<{ phone_number?: string | null; email?: string | null } | null>(null);
  const [dependentProfileForm, setDependentProfileForm] = useState<DependentSubmit>({
    profile_img: null,
    first_name: '',
    middle_name: '',
    preferred_name: '',
    last_name: '',
    email: '',
    phone_number: '',
    zip_code: '',
    state: '',
    date_of_birth: '',
    pronouns: '',
    gender_identity: '',
    gender: '',
    address1: '',
    address2: '',
    city: '',
    country: '',
    profileAddress: '',
    profileCity: '',
    language: [],
    id: 0,
    patientId: 0,
    guardian_relationship: '',
    dependent_email: '',
    group_number: '',
    insurance_through: '',
    insurance_carrier_id: 0,
    secondary_group_number: '',
    insurance_address: '',
    insurance_city: '',
    insurance_state: '',
    insurance_zip_code: '',
    secondary_member_id: '',
    secondary_iPhoneNumber: '',
    secondary_insurance_through: '',
    secondary_insurance_carrier_id: 0,
    iFirstName: '',
    iMiddleName: '',
    iDateOfBirth: '',
    iGenderIdentity: '',
    iLastName: '',
    iAddress1: '',
    iAddress2: '',
    iZipCode: '',
    state_funded_coverage_status: '',
    iState: '',
    iCity: '',
    secondary_iFirstName: '',
    secondary_iMiddleName: '',
    secondary_iDateOfBirth: '',
    secondary_iGenderIdentity: '',
    secondary_iLastName: '',
    secondary_iAddress1: '',
    secondary_iAddress2: '',
    secondary_iZipCode: '',
    secondary_iState: '',
    secondary_iCity: '',
    secondary_insurance_address: '',
    secondary_insurance_city: '',
    secondary_insurance_state: '',
    secondary_insurance_zip_code: '',
    iPhoneNumber: '',
    member_id: '',
    markers: [],
  });
  const [showValidationAddressModal, setShowValidationAddressModal] = useState<ValidationModalInterface>({
    isOpen: false,
    title: '',
    whatYouEntered: '',
    recommended: false,
    recommendedAddress: '',
    onClose: undefined,
    onConfirmChange: undefined,
    onKeepCurrentAddress: undefined,
  });

  const isAdminRole = useMemo(
    () =>
      userInfo.role.name === UserRoleName.Admin ||
      userInfo.role.name === UserRoleName.SuperAdmin ||
      userInfo.role.name === UserRoleName.OrganizationAdmin ||
      userInfo.role.name === UserRoleName.Collector,
    [userInfo.role.name],
  );
  const isAdminReviewProfile = useMemo(
    () =>
      Boolean(reviewProfile) &&
      (userInfo.role.name === UserRoleName.Admin ||
        userInfo.role.name === UserRoleName.SuperAdmin ||
        userInfo.role.name === UserRoleName.OrganizationAdmin),
    [reviewProfile, userInfo.role.name],
  );
  // A staff user completing a dependent's profile to create a case for them: when
  // the guardian was never invited to the platform, only name, date of birth and
  // the guardian relationship are required. Dependents have no invite status of
  // their own, so the guardian's decides.
  const isEssentialProfileIntake = Boolean(
    reviewProfile &&
      isStaffCaseCreationRole(userInfo.role.name) &&
      isFromSelectPatient &&
      guardianPatient?.status === 'Not Invited',
  );

  let currentOrganizationPrices: any;

  if (isFromSelectPatient) {
    currentOrganizationPrices = organizationPrices?.currentOrganizationPrices?.find(
      (currentOrganizationPrise: Pricings) =>
        currentOrganizationPrise.case_types.includes(
          values.find((item) => item.form_question_id === 20)?.value.caseType as string,
        ),
    );
  }

  const {
    register,
    handleSubmit,
    setValue,
    formState: { errors },
    getValues,
    watch,
  } = useForm<DependentSubmit>({
    mode: 'onChange',
    resolver: yupResolver(
      dependentId?.toString() === '' || dependentId === undefined || dependentId === 0
        ? dependentAddValidationSchema(addSecondaryInsurance, isAdminRole)
        : dependentUpdateValidationSchema(undefined, isAdminRole, isFromSelectPatient, isEssentialProfileIntake),
    ),
  });

  /**
   * Whether the user has changed anything since the form was last hydrated or saved. Comparing
   * `dependentProfileForm` against live form values directly is unreliable here (a save re-derives
   * it from the refetched dependent, which doesn't always format fields identically to what's
   * already in the form) — see the analogous comment in the patient `EditProfile.tsx`.
   */
  const [hasEditedSinceSave, setHasEditedSinceSave] = useState(false);

  useEffect(() => {
    setIsDirty?.(hasEditedSinceSave || avatarAction !== '');
  }, [hasEditedSinceSave, avatarAction, setIsDirty]);

  useEffect(() => {
    const subscription = watch(() => {
      if (!isHydratingFormRef.current) {
        hasUserEditedFormRef.current = true;
        setHasEditedSinceSave(true);
      }
    });

    return () => subscription.unsubscribe();
  }, [watch]);

  useEffect(() => {
    hasUserEditedFormRef.current = false;
    setHasEditedSinceSave(false);
  }, [dependentId]);

  const onChange = (k: any, value: string | number): void => {
    setValue(k, value, { shouldValidate: true });
  };
  const insuranceCarriers = useInsuranceCarriers();
  const insuranceCarrierOptions = useMemo(() => {
    return insuranceCarriers.map((insuranceCarrier) => ({
      value: insuranceCarrier.id,
      label: insuranceCarrier.name,
    }));
  }, [insuranceCarriers]);
  const selectSameAsGuardian = (isSelect = true): void => {
    const inputList = ['address1', 'address2', 'city', 'state', 'zip_code'];
    if (isSelect) {
      inputList.forEach((input) => {
        setValue(
          input as keyof DependentSubmit,
          guardianPatient?.address?.[input as keyof Address]
            ? (guardianPatient?.address?.[input as keyof Address] as string)
            : '',
          {
            shouldValidate: true,
          },
        );
      });
    } else {
      inputList.forEach((input) => {
        setValue(input as keyof DependentSubmit, input === 'state' ? undefined : '', {
          shouldValidate: true,
        });
        setKey((prev) => prev + 1);
      });
    }
  };

  const triggerProfileAvatar = React.useCallback((avatarUrl: string) => {
    setValue('profile_img', avatarUrl, { shouldValidate: true });
    setDependentProfileForm({
      ...getValues(),
      profile_img: avatarUrl,
    });
  }, []);

  const deleteSelectedDependent = async (): Promise<void> => {
    try {
      await deleteDependent(
        userInfo.role.name === UserRoleName.Admin ||
          userInfo.role.name === UserRoleName.SuperAdmin ||
          userInfo.role.name === UserRoleName.OrganizationAdmin
          ? selectedPatient.guardian_id !== null
            ? selectedPatient.guardian_id
            : selectedPatient.id
          : userInfo.id,
        dependentId as number,
      );
      setIsEditDependent(false);
      dispatch(
        editDependent({
          value: dependentId?.toString(),
          label: `${dependentProfileForm.first_name} ${dependentProfileForm.last_name}`,
          status: 'Deactivated',
        }),
      );
      if (userInfo.id) {
        dispatch(
          setSelectedPatient({
            value: userInfo.id.toString(),
            label: 'Myself',
          }),
        );
      }
    } catch (error: any) {
      const { status, data } = error.response;
      if (status === 400 || status === 422) {
        toast.error(withoutErrorCode(data.message));
      }
    }
  };

  const onCloseConfirmationModal = (): void => {
    setShowValidationAddressModal({
      isOpen: false,
      title: '',
      whatYouEntered: '',
      recommended: false,
      recommendedAddress: '',
      onClose: undefined,
      onConfirmChange: undefined,
      onKeepCurrentAddress: undefined,
    });
    setShowDeleteDependentConfirmationModal && setShowDeleteDependentConfirmationModal(false);
  };

  const onContinueConfirmationModal = (): void => {
    setShowDeleteDependentConfirmationModal && setShowDeleteDependentConfirmationModal(false);
    deleteSelectedDependent();
  };

  const checkExternalForms = async (selectedPatientId: number, updatedUser: UserProfile): Promise<string[]> => {
    const [checkProfile, checkMedicalHistory, checkMedicalConditionsFormAnswer, checkDentalHistoryFormAnswer] =
      await checkExternalFormAnswers(
        userInfo.role.name === UserRoleName.Admin ||
          userInfo.role.name === UserRoleName.SuperAdmin ||
          userInfo.role.name === UserRoleName.OrganizationAdmin
          ? guardianPatient ?? (updatedUser as UserProfile)
          : userInfo,
        updatedUser,
        userInfo.role.name,
      );

    const formsToSet: string[] = [];

    if (!checkProfile) {
      formsToSet.push('patient_profile');
    }
    if (!checkMedicalHistory) {
      formsToSet.push('patient_medical_history');
    }
    if (!checkMedicalConditionsFormAnswer) {
      formsToSet.push('patient_medical_conditions');
    }
    if (!checkDentalHistoryFormAnswer) {
      formsToSet.push('patient_dental_history');
    }

    dispatch(setExternalForms(formsToSet));
    return formsToSet;
  };

  const fetchData = (selectedPatientId: number, updatedUser: UserProfile): Promise<string[]> => {
    setFetchLoading(true);
    return checkExternalForms(selectedPatientId, updatedUser);
  };

  const callSaveProfile = async (profileData: UnifiedProfileSubmit): Promise<void> => {
    setIsSavingProfile(true);
    let id;
    let updatedUser: UserProfile | undefined;
    try {
      const isCollectorRole = userInfo.role.name === UserRoleName.Collector;
      const isCareAdvisorRole = userInfo.role.name === UserRoleName.CareAdvisor;
      const scopedStaffRole = isCollectorRole || isCareAdvisorRole ? userInfo.role.name : undefined;
      const isAdminRole =
        userInfo.role.name === UserRoleName.Admin ||
        userInfo.role.name === UserRoleName.SuperAdmin ||
        userInfo.role.name === UserRoleName.OrganizationAdmin;
      const guardianUserId =
        isAdminRole || isCollectorRole || isCareAdvisorRole
          ? selectedPatient.guardian_id !== null
            ? selectedPatient.guardian_id
            : selectedPatient.id
          : userInfo.id;

      if (!dependentId) {
        const res = await createDependent(
          guardianUserId,
          {
            guardian_relationship: (profileData as DependentSubmit).guardian_relationship!,
            email: (profileData as DependentSubmit).dependent_email || null,
          },
          { userRole: scopedStaffRole },
        );
        id = res.id;
        if (isFromSelectNeeds) {
          dispatch(
            setSelectedPatient({
              value: res.id.toString(),
              label: res.full_name,
            }),
          );
          dispatch(setSelectedPatientByAdmin({ selectedPatient: res }));
        }
      } else {
        id = dependentId;
        if (isAdminRole) {
          await updateAdminUser(id, {
            guardian_relationship: (profileData as DependentSubmit).guardian_relationship,
            email: (profileData as DependentSubmit).dependent_email || undefined,
          });
        } else {
          const res = await updateDependent(
            guardianUserId,
            id,
            {
              guardian_relationship: (profileData as DependentSubmit).guardian_relationship,
              email: (profileData as DependentSubmit).dependent_email || null,
            },
            { userRole: scopedStaffRole },
          );
          if (isFromSelectNeeds) {
            dispatch(
              setSelectedPatient({
                value: res.id.toString(),
                label: res.full_name,
              }),
            );
          }
        }
      }
      const pendingAvatarPayload = externalAvatarPayload ?? avatarPayload;
      const pendingAvatarFile = externalAvatarFile ?? avatarFile;
      const pendingAvatarAction = externalAvatarAction || avatarAction;

      if (pendingAvatarPayload && pendingAvatarFile && pendingAvatarAction === 'Upload') {
        const res = await registerAvatarMedia(pendingAvatarPayload);
        const mediaId = res.files[0].upload_id;
        const uploadResponse = await fetch(res.files[0].upload_url, {
          method: 'PUT',
          body: pendingAvatarFile,
          headers: { 'content-type': pendingAvatarFile.type },
        });
        if (!uploadResponse.ok) throw new Error(`Upload failed: ${uploadResponse.status}`);
        await confirmAvatarMedia(mediaId, id);
        triggerProfileAvatar(res.files[0].upload_url);
        onExternalAvatarSaved?.();
      } else if (pendingAvatarAction === 'Remove') {
        await deleteAvatar(id);
        triggerProfileAvatar('');
        onExternalAvatarSaved?.();
      }

      const address1 = getValues('address1')?.trim();
      const address2 = getValues('address2')?.trim();
      const city = getValues('city')?.trim();
      const state = getValues('state')?.trim();
      const zip_code = getValues('zip_code')?.trim();

      const phoneNumber = (profileData as DependentSubmit).phone_number?.trim();
      const hasAddress = !(!address1 && !address2 && !city && !state && !zip_code);
      // A cleared phone must still reach the API as an explicit null so the
      // stored number is deleted — skipping the call (or omitting the key)
      // would silently keep the old phone.
      const phoneCleared = !phoneNumber && Boolean(savedDependentRef.current?.phone_number);
      const phonePatch =
        phoneNumber && isValidPhoneNumber(phoneNumber, 'US')
          ? { phone_number: parsePhoneNumber(phoneNumber, 'US').format('E.164') }
          : phoneCleared
          ? { phone_number: null }
          : {};

      if (hasAddress || phoneNumber || phoneCleared) {
        updatedUser = await updateMe(
          {
            ...(profileData as UpdateMe),
            ...phonePatch,
            ...(hasAddress && {
              address: {
                address1: profileData.address1,
                address2: profileData.address2,
                city: profileData.city,
                state: profileData.state,
                zip_code: profileData.zip_code,
              },
            }),
          },
          id || 0,
          userInfo.role.name,
        );
      }

      const setPayload = (data: DependentSubmit): BasicInfo => {
        const { date_of_birth, first_name, preferred_name, last_name, middle_name, gender, pronouns, gender_identity } =
          data;

        const basicInfoPayload: BasicInfo = {
          date_of_birth: date_of_birth ? moment(date_of_birth).format('YYYY-MM-DD') : '',
          first_name: first_name as string,
          preferred_name: preferred_name as string,
          last_name: last_name as string,
          middle_name: middle_name as string,
          gender: gender as string,
          ...(pronouns && { pronouns }),
          gender_identity: gender_identity as string,
          languages: (profileData as DependentSubmit).language?.map((language) => language.id.toString()) || [],
        };
        return basicInfoPayload;
      };

      if (dependentId) {
        updatedUser = await saveBasicInformation(setPayload(profileData as DependentSubmit), id, userInfo.role.name);
      } else {
        updatedUser = await createBasicInformation(setPayload(profileData as DependentSubmit), id, userInfo.role.name);
      }

      // Client tags on dependents are inherited server-side; the API rejects writes.

      // Guardians (Patient role) lack the UpdateUserVerifiedEmail permission —
      // their email change already went through updateDependent above, and
      // calling this endpoint too would 403 mid-save. Compare against the
      // fetched dependent, not redux, so an unchanged email never fires a call.
      if (dependentId && userInfo.role.name !== UserRoleName.Patient) {
        const nextEmail = ((profileData as DependentSubmit).dependent_email || '').trim();
        // The backend 400s on an empty email, so only PATCH when there's an
        // actual new value to set, not when the field is simply left blank.
        if (nextEmail && (savedDependentRef.current?.email || '').trim() !== nextEmail) {
          await updateVerifiedEmail(dependentId, { email: nextEmail });
        }
      }

      if (
        (dependentId === undefined || dependentId === 0 || dependentId.toString() === '') &&
        (profileData as DependentSubmit).insurance_through !== 'none' &&
        (profileData as DependentSubmit).insurance_through !== '' &&
        (profileData as DependentSubmit).insurance_through !== undefined
      ) {
        const dataWithUpdatedInsurance = updateDataInsurance(profileData as DependentSubmit);
        const insuranceArray: Insurance[] = [];
        if (
          dataWithUpdatedInsurance.insured_by !== '' ||
          dataWithUpdatedInsurance.insurance_membership !== undefined ||
          dataWithUpdatedInsurance.insurance_through !== undefined
        )
          insuranceArray.push(dataWithUpdatedInsurance);
        if (addSecondaryInsurance) {
          const dataWithUpdatedSecondaryInsurance = updateDataSecondaryInsurance(profileData as DependentSubmit);
          insuranceArray.push(dataWithUpdatedSecondaryInsurance);
        }
        await createPatientInsurance({
          user_id: id,
          insurance: insuranceArray,
        });
      }

      if (!dependentId) {
        dispatch(
          addDependent({
            value: id.toString(),
            label: `${profileData.first_name} ${profileData.last_name}`,
            status: 'Active',
          }),
        );
      } else {
        dispatch(
          editDependent({
            value: id.toString(),
            label: `${profileData.first_name} ${profileData.last_name}`,
            status: 'Active',
          }),
        );
      }
      hasUserEditedFormRef.current = false;
      setHasEditedSinceSave(false);
      if (setIsEditDependent) setIsEditDependent(false);
      onSaveSuccess?.();
    } catch (error: unknown) {
      displayErrorDetails(error);
    } finally {
      setIsSavingProfile(false);
      // A failed save leaves updatedUser unset; dispatching it anyway would
      // wipe the redux patient selection (the reducer replaces blindly) and
      // break every retry on the guardian_id derefs above.
      if (updatedUser) {
        dispatch(setSelectedPatientByAdmin({ selectedPatient: updatedUser as UserProfile }));
        if (roleName === UserRoleName.Dependent) setThisUser(updatedUser as UserProfile);
      }
      if (updatedUser && isFromSelectPatient) {
        fetchData(id || 0, updatedUser as UserProfile);
        dispatch(setIsFromSelectPatient(false));
        dispatch(setDependentId(null));

        const caseSubjectId = id ?? (updatedUser as UserProfile)?.id;
        const caseSubjectState = (updatedUser as UserProfile)?.address?.state ?? '';

        if (caseSubjectId && updatedUser) {
          dispatch(
            setSelectedPatient({
              value: String(caseSubjectId),
              label: (updatedUser as UserProfile).full_name ?? '',
            }),
          );
        }

        const continueIntakeNavigate = (path: string, navState: Record<string, unknown>): void => {
          if (isUnifiedStaffCaseIntakeRole(userInfo.role.name)) {
            dispatch(setStaffIntakeInProgress(true));
          }
          // `replace`: once the profile is saved it is no longer part of the
          // intake, so Back from the next step returns to the case type
          // selection rather than to this profile with the intake flag cleared.
          roleNavigate(path, { state: navState, replace: true });
        };

        if (
          (values.find((item) => item.form_question_id === 20)?.value.caseType as string) ===
          CaseType.oral_health_coaching
        ) {
          // Coaching is booked with a care advisor, not a provider: same next step as
          // CreateConsultationFor takes when the dependent's profile was already complete.
          continueIntakeNavigate('/select-care-advisor', {
            caseType: CaseType.oral_health_coaching,
            insuranceCarrierId: '',
            customInsuranceCarrier: '',
            userOrganization: currentOrganization.id,
            patientId: caseSubjectId,
          });
        } else if (
          (values.find((item) => item.form_question_id === 20)?.value.caseType as string) === 'video_call_scheduled' ||
          (values.find((item) => item.form_question_id === 20)?.value.caseType as string) ===
            CaseType.phone_call_scheduled
        ) {
          continueIntakeNavigate('/select-provider', {
            caseType: values.find((item) => item.form_question_id === 20)?.value.caseType as string as string,
            insuranceCarrierId: '',
            customInsuranceCarrier: '',
            userOrganization: currentOrganization.id,
            patientId: caseSubjectId,
          });
        } else if (
          (values.find((item) => item.form_question_id === 20)?.value.caseType as string) === CaseType.second_opinion ||
          (values.find((item) => item.form_question_id === 20)?.value.caseType as string) === CaseType.one_report
        ) {
          // Same next step CreateConsultationFor takes for these case types when the
          // dependent's profile was already complete; the catch-all /describe-pain-level
          // below skipped the medical-history and pharmacy steps.
          continueIntakeNavigate(userInfo.role.name === UserRoleName.Admin ? '/select-pharmacy' : '/clinical-data', {
            caseType: values.find((item) => item.form_question_id === 20)?.value.caseType as string,
            patientState: caseSubjectState,
            userOrganization: currentOrganization.id,
            patientId: caseSubjectId,
          });
        } else if (
          (values.find((item) => item.form_question_id === 20)?.value.caseType as string) === CaseType.care_coordination
        ) {
          // Same gate as the patient self-flow in
          // Profile/EditProfile.tsx and Dependent/EditDependent.tsx:
          // CC must skip the medical / dental clinical-data and
          // pain-level questionnaires entirely, even for a brand-new
          // patient. Without this explicit branch, CC + paid (or
          // CC + amount-zero with payment options / insurance to
          // collect) fell into the catch-all /describe-pain-level
          // below.
          if (!needsPayment(currentOrganizationPrices)) {
            continueIntakeNavigate('/select-patient', {
              caseType: CaseType.care_coordination,
            });
          } else {
            continueIntakeNavigate('/payment-information', {
              caseType: CaseType.care_coordination,
            });
          }
        } else if (
          (values.find((item) => item.form_question_id === 20)?.value.caseType as string) ===
          CaseType.clinical_enablement
        ) {
          // Resume where CreateConsultationFor sends this case type when the
          // profile was already complete: photos come first, then the
          // medical-history steps. The catch-all /describe-pain-level below
          // skipped both, so a brand-new dependent's case had no photos.
          continueIntakeNavigate('/upload-image', {
            caseType: CaseType.clinical_enablement,
            patientState: caseSubjectState,
            userOrganization: currentOrganization.id,
            patientId: caseSubjectId,
          });
        } else {
          continueIntakeNavigate('/describe-pain-level', {
            caseType: values.find((item) => item.form_question_id === 20)?.value.caseType as string,
            patientState: caseSubjectState,
            userOrganization: currentOrganization.id,
            patientId: caseSubjectId,
          });
        }
      }
      // No else-branch: when admin saves a dependent profile from the
      // Users / review-profile path (i.e. NOT inside the staff intake
      // flow), they should stay on the profile page and see the
      // confirmation toast wired through `setSaveSuccess`. The previous
      // `else if (isAdminReviewProfile && roleName === Dependent)`
      // branch unconditionally jumped to `/create-consultation-for`,
      // shoving the admin into case creation after every routine save
      // (e.g. fixing a missing address) — which is the explicit
      // path the "Create new case" button at the top of the same page
      // already provides for.
    }
  };

  const updateCurrentAddress = (standardizedAddress: any, postalAddress: any, addressComponents: any): void => {
    const streetNumber = addressComponents.find(
      (addressComponent: any) => addressComponent.componentType === 'street_number',
    );
    const address1 = addressComponents.find((addressComponent: any) => addressComponent.componentType === 'route');
    if (postalAddress) setValue('city', postalAddress.locality, { shouldValidate: true });
    if (streetNumber || address1) {
      setValue('address1', `${streetNumber.componentName.text} ${address1.componentName.text}`, {
        shouldValidate: true,
      });
    }
    if (standardizedAddress?.state) setValue('state', standardizedAddress.state, { shouldValidate: true });
    if (postalAddress) setValue('zip_code', postalAddress.postalCode, { shouldValidate: true });
  };

  const onSubmit = async (profileData: DependentSubmit): Promise<void> => {
    const hasAddress = [
      profileData.address1,
      profileData.address2,
      profileData.city,
      profileData.state,
      profileData.zip_code,
    ].some((value) => value?.trim());
    if (isEssentialProfileIntake && !hasAddress) {
      await callSaveProfile(profileData);
      return;
    }
    await validateAddress(
      profileData,
      getValues as UseFormGetValues<UnifiedProfileSubmit>,
      validationResponseId,
      callSaveProfile,
      setValidationResponseId,
      setShowValidationAddressModal,
      onCloseConfirmationModal,
      updateCurrentAddress,
    );
  };

  const onInvalid = (errorsList: any): void => {
    const error = Object.values(errorsList)[0] as any;
    if (error) {
      toast.error(error.message as string);
    }
  };

  const onCancelEditDependent = (): void => {
    // `setIsEditDependent(false)` can unmount this component in the same render (when
    // `isAdminReviewProfile` doesn't also keep it mounted), so nothing else gets the chance to
    // propagate the reset `hasEditedSinceSave` to the parent — clear it directly here instead.
    hasUserEditedFormRef.current = false;
    setHasEditedSinceSave(false);
    setIsDirty?.(false);
    setIsEditDependent(false);
    if (isFromSelectPatient) {
      dispatch(setIsFromSelectPatient(false));
      dispatch(setDependentId(null));
      if (
        !isAdminRole &&
        userInfo.role.name !== UserRoleName.Collector &&
        userInfo.role.name !== UserRoleName.CareAdvisor
      ) {
        roleNavigate('/select-patient', {
          state: { caseType: values.find((item) => item.form_question_id === 20)?.value.caseType as string },
        });
      } else {
        const roleName = selectedPatient.role?.name ?? UserRoleName.Dependent;
        navigate(
          `${getStaffReviewProfileBasePath(userInfo.role.name)}/${roleName}/${
            selectedPatient.id
          }/create-consultation-for`,
          { state: { caseType: values.find((item) => item.form_question_id === 20)?.value.caseType as string } },
        );
      }
    }
  };

  const convertResponseToFormData = (data: Dependent, insuranceData: Insurance[]): DependentSubmit => {
    const { id, guardian_relationship, basic_info, picture_media_id, patient_profile, ...rest } = data;
    const primaryInsurance = patientInsurance?.find((i) => !i.is_secondary);
    const secondaryInsurance = patientInsurance?.find((i) => i.is_secondary);
    const dependentData: DependentSubmit = {
      ...rest,
      profile_img: '',
      first_name: basic_info?.first_name,
      preferred_name: basic_info?.preferred_name || '',
      middle_name: basic_info?.middle_name || '',
      last_name: basic_info?.last_name,
      email: rest.email || '',
      // The API returns null for an unset phone, gender or address field; the
      // form (and its non-nullable string schema) expects ''. A null here
      // fails validation with a type error instead of the field's own message.
      phone_number: rest.phone_number || '',
      zip_code: data?.address?.zip_code || '',
      state: data?.address?.state || '',
      date_of_birth: basic_info?.date_of_birth ? moment(basic_info.date_of_birth).format('MM/DD/YYYY') : '',
      pronouns: basic_info?.pronouns || '',
      gender_identity: basic_info?.gender_identity || '',
      gender: basic_info?.gender || '',
      address1: data?.address?.address1 || '',
      address2: data?.address?.address2 || '',
      city: data?.address?.city || '',
      country: data?.address?.country,
      profileAddress: data?.address?.address1,
      profileCity: data?.address?.city,
      id,
      patientId: id,
      guardian_relationship: guardian_relationship || '',
      dependent_email: rest.email || '',
      language:
        (basic_info?.languages?.map(
          (language) => languageOptions.find((option) => option.label === language.name) || null,
        ) as MultiValue<OptionLanguage>) || ([] as MultiValue<OptionLanguage>),
      state_funded_coverage_status:
        insuranceData && primaryInsurance ? primaryInsurance.state_funded_coverage_status : '',
      insurance_through: insuranceData && primaryInsurance?.insured_by ? primaryInsurance.insured_by : 'none',
      member_id:
        insuranceData && primaryInsurance?.insurance_membership ? primaryInsurance?.insurance_membership.member_id : '',
      group_number:
        insuranceData && primaryInsurance?.insurance_membership
          ? primaryInsurance?.insurance_membership.group_number
          : '',
      insurance_address:
        insuranceData && primaryInsurance?.insurance_membership
          ? primaryInsurance?.insurance_membership.address?.address1
          : '',
      insurance_city:
        insuranceData && primaryInsurance?.insurance_membership
          ? primaryInsurance?.insurance_membership.address?.city
          : '',
      insurance_state:
        insuranceData && primaryInsurance?.insurance_membership
          ? primaryInsurance?.insurance_membership.address?.state
          : '',
      insurance_zip_code:
        insuranceData && primaryInsurance?.insurance_membership
          ? primaryInsurance?.insurance_membership.address?.zip_code
          : '',
      iFirstName: (insuranceData && primaryInsurance?.insurance_through?.first_name) || '',
      iMiddleName: (insuranceData && primaryInsurance?.insurance_through?.middle_name) || '',
      iLastName: (insuranceData && primaryInsurance?.insurance_through?.last_name) || '',
      iDateOfBirth:
        insuranceData && primaryInsurance?.insurance_through
          ? moment(primaryInsurance?.insurance_through?.date_of_birth).format('MM/DD/YYYY')
          : '',
      iGenderIdentity: (insuranceData && primaryInsurance?.insurance_through?.gender_identity) || '',
      iAddress1: (insuranceData && primaryInsurance?.insurance_through?.address?.address1) || '',
      iAddress2: (insuranceData && primaryInsurance?.insurance_through?.address?.address2) || '',
      iZipCode: (insuranceData && primaryInsurance?.insurance_through?.address?.zip_code) || '',
      iState: (insuranceData && primaryInsurance?.insurance_through?.address?.state) || '',
      iCity: (insuranceData && primaryInsurance?.insurance_through?.address?.city) || '',
      iPhoneNumber:
        insuranceData && primaryInsurance?.insurance_membership
          ? primaryInsurance?.insurance_membership.phone_number
          : '',
      insurance_carrier_id: insuranceData && primaryInsurance?.insurance_membership?.insurance_carrier_id,

      secondary_insurance_through:
        insuranceData && secondaryInsurance?.insured_by ? secondaryInsurance.insured_by : 'none',
      secondary_member_id:
        insuranceData && secondaryInsurance?.insurance_membership
          ? secondaryInsurance.insurance_membership.member_id
          : '',
      secondary_group_number:
        insuranceData && secondaryInsurance?.insurance_membership
          ? secondaryInsurance.insurance_membership.group_number
          : '',
      secondary_insurance_address:
        insuranceData && secondaryInsurance?.insurance_membership
          ? secondaryInsurance.insurance_membership?.address?.address1 || ''
          : '',
      secondary_insurance_city:
        insuranceData && secondaryInsurance?.insurance_membership
          ? secondaryInsurance.insurance_membership?.address?.city || ''
          : '',
      secondary_insurance_state:
        insuranceData && secondaryInsurance?.insurance_membership
          ? secondaryInsurance.insurance_membership?.address?.state || ''
          : '',
      secondary_insurance_zip_code:
        insuranceData && secondaryInsurance?.insurance_membership
          ? secondaryInsurance.insurance_membership?.address?.zip_code || ''
          : '',
      secondary_iFirstName: (insuranceData && secondaryInsurance?.insurance_through?.first_name) || '',
      secondary_iMiddleName: (insuranceData && secondaryInsurance?.insurance_through?.middle_name) || '',
      secondary_iLastName: (insuranceData && secondaryInsurance?.insurance_through?.last_name) || '',
      secondary_iDateOfBirth:
        insuranceData && secondaryInsurance?.insurance_through
          ? moment(secondaryInsurance?.insurance_through?.date_of_birth).format('MM/DD/YYYY')
          : '',
      secondary_iGenderIdentity: (insuranceData && secondaryInsurance?.insurance_through?.gender_identity) || '',
      secondary_iAddress1: (insuranceData && secondaryInsurance?.insurance_through?.address?.address1) || '',
      secondary_iAddress2: (insuranceData && secondaryInsurance?.insurance_through?.address?.address2) || '',
      secondary_iZipCode: (insuranceData && secondaryInsurance?.insurance_through?.address?.zip_code) || '',
      secondary_iState: (insuranceData && secondaryInsurance?.insurance_through?.address?.state) || '',
      secondary_iCity: (insuranceData && secondaryInsurance?.insurance_through?.address?.city) || '',
      secondary_iPhoneNumber:
        insuranceData && secondaryInsurance?.insurance_membership
          ? secondaryInsurance.insurance_membership.phone_number
          : '',
      secondary_insurance_carrier_id: insuranceData && secondaryInsurance?.insurance_membership?.insurance_carrier_id,
    };

    return dependentData;
  };

  const setInitialValues = (data: Dependent | UserProfile, insuranceData: Insurance[]): void => {
    if (hasUserEditedFormRef.current) return;

    const dependentData = convertResponseToFormData(data as Dependent, insuranceData);

    isHydratingFormRef.current = true;
    try {
      Object.keys(dependentData).forEach((k) => {
        setValue(k as keyof DependentSubmit, dependentData[k as keyof DependentSubmit]);
      });

      setDependentProfileForm(dependentData);
    } finally {
      isHydratingFormRef.current = false;
    }
  };
  const setTextValue = (e: React.ChangeEvent<HTMLInputElement>, name: string): void => {
    const { value } = e.target;
    setValue(name as keyof DependentSubmit, value, { shouldValidate: true });
    setSelection([e.target.selectionStart, e.target.selectionEnd]);
  };

  const stateFundedCoverageStatus = watch('state_funded_coverage_status');
  const insuranceThrough = watch('insurance_through');

  useEffect(() => {
    if (stateFundedCoverageStatus !== '') {
      setIsSelected(Number(stateFundedProgramOptions.find((answer) => answer.value === stateFundedCoverageStatus)?.id));
    }
  }, [stateFundedCoverageStatus]);

  useEffect(() => {
    if (insuranceThrough === 'none') {
      setAddSecondaryInsurance(false);
    }
  }, [insuranceThrough]);

  useEffect(() => {
    // Fires on the initial avatar fetch too (image goes from undefined to a URL on mount),
    // which isn't a user edit — guard with isHydratingFormRef so the watch subscription
    // above doesn't mark the form dirty and trigger a false "unsaved changes" prompt.
    if (!image) return;
    isHydratingFormRef.current = true;
    try {
      triggerProfileAvatar(image);
    } finally {
      isHydratingFormRef.current = false;
    }
  }, [image, triggerProfileAvatar]);

  useEffect(() => {
    hasFetchedDependentRef.current = false;
    hasFetchedGuardianRef.current = false;
    // Without this reset the new-dependent form (which never fetches) would
    // keep the previously edited dependent's phone/email and mis-detect a
    // clear against the fresh record.
    savedDependentRef.current = null;

    const fetchAllData = async () => {
      const scopedStaffRole =
        userInfo.role.name === UserRoleName.Collector || userInfo.role.name === UserRoleName.CareAdvisor
          ? userInfo.role.name
          : undefined;

      if (!hasFetchedGuardianRef.current) {
        hasFetchedGuardianRef.current = true;
        if (userInfo.role.name === UserRoleName.Patient) {
          setGuardianPatient(userInfo);
        } else if (selectedPatient?.id) {
          try {
            const guardianId = selectedPatient.guardian_id ?? selectedPatient.id;
            const guardian = await getUserById(guardianId, scopedStaffRole);
            setGuardianPatient(guardian);
          } catch (err) {
            displayErrorDetails(err);
          }
        }
      }

      if (!dependentId) return;

      setFetchLoading(true);
      try {
        const dependent =
          userInfo.role.name === UserRoleName.Patient
            ? await getDependentById(userInfo.id, dependentId)
            : await getUserById(dependentId, scopedStaffRole);

        const insurance = await getPatientInsurance(dependentId);

        setPatientInsurance(insurance);
        savedDependentRef.current = {
          phone_number: (dependent as Dependent).phone_number,
          email: (dependent as Dependent).email,
        };
        setInitialValues(dependent as Dependent, insurance);
        dispatch(setSelectedPatientByAdmin({ selectedPatient: dependent }));

        hasFetchedDependentRef.current = true;

        if (!hasFetchedGuardianRef.current) {
          hasFetchedGuardianRef.current = true;
          const guardianId = (dependent as Dependent).guardian_id;
          if (userInfo.role.name === UserRoleName.Patient) {
            setGuardianPatient(userInfo);
          } else if (guardianId) {
            try {
              const guardian = await getUserById(guardianId, scopedStaffRole);
              setGuardianPatient(guardian);
            } catch (err) {
              console.error('Failed to fetch guardian', err);
            }
          }
        }
      } catch (error) {
        console.error('Error fetching dependent or insurance:', error);
        displayErrorDetails(error);
      } finally {
        setFetchLoading(false);
      }
    };

    fetchAllData();
  }, [dependentId, userInfo.id, userInfo.role.name, dispatch]);

  const isAdminReview = isAdminRole && Boolean(reviewProfile);
  const shouldShowProfileChrome = !isAdminReview;
  const isNewDependent = dependentId === undefined || dependentId === 0 || dependentId.toString() === '';
  const shouldShowNewDependentInsurance = shouldShowProfileChrome && isNewDependent;
  const shouldShowAdminNewDependentAvatar = isAdminReview && isNewDependent;

  return (
    <>
      {!isModal && !isFromSelectPatient && shouldShowProfileChrome && (
        <div className={styles.backToPrimaryProfileBtn}>
          <button type="button" className={styles.backBtn} onClick={onCancelEditDependent}>
            <MdKeyboardArrowLeft />
            Back to Primary Profile
          </button>
        </div>
      )}
      <div className={styles.editProfileContainer}>
        {(shouldShowProfileChrome || isAdminReview) && !shouldShowAdminNewDependentAvatar && (
          <div className={styles.titleContainer}>
            <span className={styles.title}>{isAdminReview ? 'Basic information' : 'Dependent Profile'}</span>
          </div>
        )}
        {shouldShowAdminNewDependentAvatar && (
          <div className={styles.titleContainer}>
            <ProfileImage
              id={undefined}
              setAvatarFile={setAvatarFile}
              setAvatarPayload={setAvatarPayload}
              setAvatarAction={setAvatarAction}
              setImage={setImage}
              image={image}
              size="80px"
              isNewDependent
              triggerProfileAvatar={triggerProfileAvatar}
              givingUserProfile={dependentProfileForm}
            />
          </div>
        )}
        <div className={styles.editContainer}>
          {/* Avatar */}
          {!isAdminReview && (
            <ProfileImage
              id={dependentId ? dependentId.toString() : undefined}
              setAvatarFile={setAvatarFile}
              setAvatarPayload={setAvatarPayload}
              setAvatarAction={setAvatarAction}
              setImage={setImage}
              image={image}
              size="80px"
              isNewDependent={isNewDependent}
              triggerProfileAvatar={triggerProfileAvatar}
              givingUserProfile={dependentProfileForm}
            />
          )}

          {/* Guardian relationship */}
          <Box className={addNewUserStyles.row} sx={{ display: 'flex', gap: 2, flexWrap: 'wrap', mb: 3, pt: 2 }}>
            <Box className={addNewUserStyles.inputWrap}>
              <MUISelectInput
                name="guardian_relationship"
                label="Guardian's relationship to Dependent *"
                value={
                  relationshipOptions.find((option) => option.label === getValues('guardian_relationship'))?.value || ''
                }
                onChange={(v: string) => {
                  const found = relationshipOptions.find((o) => o.value === v);
                  if (found) setValue('guardian_relationship', found.label, { shouldValidate: true });
                }}
                options={relationshipOptions}
              />
            </Box>
          </Box>

          <form ref={formRef} className={styles.formContainer} onSubmit={handleSubmit(onSubmit, onInvalid)}>
            {/* Name row */}
            <Box sx={{ display: 'flex', gap: 2, flexWrap: 'wrap', mb: 3 }}>
              <MuiTextField
                name="first_name"
                label="First name"
                required
                value={getValues('first_name')}
                onChange={(e) => setTextValue(e, 'first_name')}
                wrapperClassName={`fs-exclude ${addNewUserStyles.inputWrap}`}
              />
              <MuiTextField
                name="middle_name"
                label="Middle name (optional)"
                value={getValues('middle_name')}
                onChange={(e) => setTextValue(e, 'middle_name')}
                wrapperClassName={`fs-exclude ${addNewUserStyles.inputWrap}`}
              />
              <MuiTextField
                name="last_name"
                label="Last name"
                required
                value={getValues('last_name')}
                onChange={(e) => setTextValue(e, 'last_name')}
                wrapperClassName={`fs-exclude ${addNewUserStyles.inputWrap}`}
              />
            </Box>

            {/* DOB + preferred name row */}
            <Box sx={{ display: 'flex', gap: 2, flexWrap: 'wrap', mb: 3 }}>
              <MuiTextField
                name="preferred_name"
                label="Preferred name (optional)"
                value={getValues('preferred_name')}
                onChange={(e) => setTextValue(e, 'preferred_name')}
                wrapperClassName={`fs-exclude ${addNewUserStyles.inputWrap}`}
              />
              <MuiTextField
                name="date_of_birth"
                label="Date of birth"
                required
                placeholder="MM / DD / YYYY"
                value={getValues('date_of_birth') as string}
                onChange={(e) => dateAutoSlashes(e, 'date_of_birth', setValue)}
                maxLength={10}
                wrapperClassName={`fs-exclude ${addNewUserStyles.inputWrap}`}
              />
            </Box>

            {/* Gender / identity / pronouns row */}
            <Box sx={{ display: 'flex', gap: 2, flexWrap: 'wrap', mb: 3 }}>
              <Box className={addNewUserStyles.inputWrap}>
                <MUISelectInput
                  name="gender"
                  label={`Gender assigned at birth${dependentId && !isEssentialProfileIntake ? ' *' : ''}`}
                  value={getValues('gender') || ''}
                  onChange={(v: string) => setValue('gender', v, { shouldValidate: true })}
                  options={genderOptions}
                />
              </Box>
              <Box className={addNewUserStyles.inputWrap}>
                <MUISelectInput
                  name="gender_identity"
                  label={`Gender identity${
                    (isAdminRole && !isFromSelectPatient) || isEssentialProfileIntake ? '' : ' *'
                  }`}
                  value={getValues('gender_identity') || ''}
                  onChange={(v: string) => setValue('gender_identity', v, { shouldValidate: true })}
                  options={genderIdentity}
                />
              </Box>
              <Box className={addNewUserStyles.inputWrap}>
                <MUISelectInput
                  name="pronouns"
                  label="Preferred pronouns (optional)"
                  value={getValues('pronouns') || ''}
                  onChange={(v: string) => setValue('pronouns', v, { shouldValidate: true })}
                  options={pronounsOptions}
                />
              </Box>
            </Box>

            {/* Languages row */}
            <Box className={addNewUserStyles.row} sx={{ mb: 2 }}>
              <MultiSelectInputMUI
                name="language"
                label={`Languages${dependentId && !isEssentialProfileIntake ? ' *' : ''}`}
                styledTag
                value={((getValues('language') as OptionLanguage[]) || []).map((l) => String(l.id))}
                onChange={(ids: string[]) =>
                  setValue(
                    'language',
                    languageOptions.filter((l) => ids.includes(String(l.id))) as MultiValue<OptionLanguage>,
                    { shouldValidate: true },
                  )
                }
                options={languageOptions}
                wrapperClassName={`fs-exclude ${addNewUserStyles.inputWrap}`}
              />
            </Box>
            {/* Same as Guardian + address */}
            <FormControlLabel
              className={collectorStyles.sameAddressCheckboxRow}
              label={<span className={collectorStyles.sameAddressCheckboxLabel}>Same as Guardian</span>}
              control={
                <Checkbox
                  checked={
                    getValues('address1') === guardianPatient?.address?.address1 &&
                    getValues('address2') === guardianPatient?.address?.address2 &&
                    getValues('city') === guardianPatient?.address?.city &&
                    guardianPatient?.address?.state !== undefined &&
                    getValues('state') !== undefined &&
                    getValues('state') === guardianPatient?.address?.state &&
                    getValues('zip_code') === guardianPatient?.address?.zip_code
                  }
                  onChange={(_event, checked) => selectSameAsGuardian(checked)}
                  disabled={!guardianPatient?.address?.address1}
                />
              }
            />
            <div key={key} className={styles.row} style={{ marginBottom: '24px' }}>
              <AddressSection
                register={register}
                errors={errors}
                getValues={getValues}
                setTextValue={setTextValue}
                setValue={setValue}
                showValidationAddressModal={showValidationAddressModal}
                required={!!dependentId && !isEssentialProfileIntake}
              />
            </div>

            {/* Email & phone */}
            <Box sx={{ display: 'flex', gap: 2, flexWrap: 'wrap', mb: 3 }}>
              <MuiTextField
                name="dependent_email"
                label="Email address (optional)"
                value={getValues('dependent_email')}
                onChange={(e) => setTextValue(e, 'dependent_email')}
                wrapperClassName={`fs-exclude ${addNewUserStyles.inputWrap}`}
              />
              <MuiPhoneInput
                value={getValues('phone_number') as E164Number}
                name="phone_number"
                onChange={(v) => setValue('phone_number', v ?? '', { shouldValidate: true })}
                label="Phone number"
                wrapperClassName={`fs-exclude ${addNewUserStyles.inputWrap}`}
              />
            </Box>

            {/* Insurance section — new dependent only */}
            {shouldShowNewDependentInsurance && (
              <>
                <div className={styles.separator} />
                <div className={styles.editProfileContainer}>
                  <div className={styles.titleContainer}>
                    <span className={styles.title}>Insurance Information</span>
                  </div>
                  <div className={styles.editContainer}>
                    <Box sx={{ mb: 2 }}>
                      <MUISelectInput
                        name="insurance_through"
                        label="I'm Insured By"
                        value={getValues('insurance_through') || ''}
                        onChange={(v: string) => setValue('insurance_through', v, { shouldValidate: true })}
                        options={insuranceThroughOptions}
                        wrapperClassName={addNewUserStyles.inputWrap}
                      />
                    </Box>
                    {getValues('insurance_through') &&
                      getValues('insurance_through') !== 'none' &&
                      getValues('insurance_through') !== undefined && (
                        <>
                          <Box sx={{ mb: 2 }}>
                            <MUISelectInput
                              name="insurance_carrier_id"
                              label="Insurance company *"
                              value={String(getValues('insurance_carrier_id') || '')}
                              onChange={(v: string) =>
                                setValue('insurance_carrier_id', Number(v), { shouldValidate: true })
                              }
                              options={insuranceCarrierOptions.map((o) => ({ value: String(o.value), label: o.label }))}
                              wrapperClassName={addNewUserStyles.inputWrap}
                            />
                          </Box>
                          <Box sx={{ display: 'flex', gap: 2, flexWrap: 'wrap', mb: 2 }}>
                            <MuiTextField
                              name="member_id"
                              label="Member ID *"
                              value={getValues('member_id')}
                              onChange={(e) => {
                                setValue('member_id', e.target.value, { shouldValidate: true });
                                setSelection([e.target.selectionStart, e.target.selectionEnd]);
                              }}
                              wrapperClassName={`fs-exclude ${addNewUserStyles.inputWrap}`}
                            />
                            <MuiTextField
                              name="group_number"
                              label="Group Number *"
                              value={getValues('group_number')}
                              onChange={(e) => {
                                setValue('group_number', e.target.value, { shouldValidate: true });
                                setSelection([e.target.selectionStart, e.target.selectionEnd]);
                              }}
                              wrapperClassName={`fs-exclude ${addNewUserStyles.inputWrap}`}
                            />
                          </Box>
                          <Box sx={{ mb: 2 }}>
                            <MuiPhoneInput
                              value={getValues('iPhoneNumber') as E164Number}
                              name="iPhoneNumber"
                              onChange={(v) => setValue('iPhoneNumber', v ?? '', { shouldValidate: true })}
                              label="Phone number at the back of your insurance card *"
                              wrapperClassName={`fs-exclude ${addNewUserStyles.inputWrap}`}
                            />
                          </Box>
                          <Box sx={{ display: 'flex', gap: 2, flexWrap: 'wrap', mb: 2 }}>
                            <MuiTextField
                              name="insurance_address"
                              label="Insurance Address *"
                              value={getValues('insurance_address')}
                              onChange={(e) => onChange('insurance_address', e.target.value)}
                              wrapperClassName={`fs-exclude ${addNewUserStyles.inputWrap}`}
                            />
                            <MuiTextField
                              name="insurance_city"
                              label="Insurance City *"
                              value={getValues('insurance_city')}
                              onChange={(e) => onChange('insurance_city', e.target.value)}
                              wrapperClassName={`fs-exclude ${addNewUserStyles.inputWrap}`}
                            />
                          </Box>
                          <Box sx={{ display: 'flex', gap: 2, flexWrap: 'wrap', mb: 2 }}>
                            <Box className={addNewUserStyles.inputWrap}>
                              <MUISelectInput
                                name="insurance_state"
                                label="Insurance State *"
                                value={getValues('insurance_state') || ''}
                                onChange={(v: string) => onChange('insurance_state', v)}
                                options={stateOptions}
                              />
                            </Box>
                            <MuiTextField
                              name="insurance_zip_code"
                              label="Insurance Zip Code *"
                              value={getValues('insurance_zip_code')}
                              onChange={(e) => onChange('insurance_zip_code', e.target.value)}
                              wrapperClassName={`fs-exclude ${addNewUserStyles.inputWrap}`}
                            />
                          </Box>
                        </>
                      )}
                    {getValues('insurance_through') &&
                      getValues('insurance_through') !== 'myself' &&
                      getValues('insurance_through') !== 'none' &&
                      getValues('insurance_through') !== undefined && (
                        <div className={styles.insuranceThroughContainer}>
                          <Box sx={{ display: 'flex', gap: 2, flexWrap: 'wrap', mb: 2 }}>
                            <MuiTextField
                              name="iFirstName"
                              label="Insurance Holder's First Name"
                              value={getValues('iFirstName')}
                              onChange={(e) => {
                                setValue('iFirstName', e.target.value, { shouldValidate: true });
                                setSelection([e.target.selectionStart, e.target.selectionEnd]);
                              }}
                              wrapperClassName={`fs-exclude ${addNewUserStyles.inputWrap}`}
                            />
                            <MuiTextField
                              name="iMiddleName"
                              label="Insurance Holder's Middle Name"
                              value={getValues('iMiddleName')}
                              onChange={(e) => {
                                setValue('iMiddleName', e.target.value, { shouldValidate: true });
                                setSelection([e.target.selectionStart, e.target.selectionEnd]);
                              }}
                              wrapperClassName={`fs-exclude ${addNewUserStyles.inputWrap}`}
                            />
                            <MuiTextField
                              name="iLastName"
                              label="Insurance Holder's Last Name"
                              value={getValues('iLastName')}
                              onChange={(e) => {
                                setValue('iLastName', e.target.value, { shouldValidate: true });
                                setSelection([e.target.selectionStart, e.target.selectionEnd]);
                              }}
                              wrapperClassName={`fs-exclude ${addNewUserStyles.inputWrap}`}
                            />
                          </Box>
                          <Box sx={{ mb: 2 }}>
                            <MuiTextField
                              name="iDateOfBirth"
                              label="Insurance Holder's Date of Birth"
                              value={getValues('iDateOfBirth')}
                              onChange={(e) => {
                                setValue('iDateOfBirth', checkAndSetDate(e), { shouldValidate: true });
                                setSelection([e.target.selectionStart, e.target.selectionEnd]);
                              }}
                              maxLength={10}
                              wrapperClassName={`fs-exclude ${addNewUserStyles.inputWrap}`}
                            />
                          </Box>
                          <Box sx={{ mb: 2 }}>
                            <MUISelectInput
                              name="iGenderIdentity"
                              label="Insurance Holder's Gender Identity"
                              value={getValues('iGenderIdentity') || ''}
                              onChange={(v: string) => setValue('iGenderIdentity', v, { shouldValidate: true })}
                              options={genderIdentity}
                              wrapperClassName={addNewUserStyles.inputWrap}
                            />
                          </Box>
                          <Box sx={{ display: 'flex', gap: 2, flexWrap: 'wrap', mb: 2 }}>
                            <MuiTextField
                              name="iAddress1"
                              label="Insurance Holder's Street Address"
                              value={getValues('iAddress1')}
                              onChange={(e) => {
                                setValue('iAddress1', e.target.value, { shouldValidate: true });
                                setSelection([e.target.selectionStart, e.target.selectionEnd]);
                              }}
                              wrapperClassName={`fs-exclude ${addNewUserStyles.inputWrap}`}
                            />
                            <MuiTextField
                              name="iAddress2"
                              label="Apt, suite, building (optional)"
                              value={getValues('iAddress2')}
                              onChange={(e) => {
                                setValue('iAddress2', e.target.value, { shouldValidate: true });
                                setSelection([e.target.selectionStart, e.target.selectionEnd]);
                              }}
                              wrapperClassName={`fs-exclude ${addNewUserStyles.inputWrap}`}
                            />
                          </Box>
                          <Box sx={{ display: 'flex', gap: 2, flexWrap: 'wrap', mb: 2 }}>
                            <MuiTextField
                              name="iCity"
                              label="City"
                              value={getValues('iCity')}
                              onChange={(e) => {
                                setValue('iCity', e.target.value, { shouldValidate: true });
                                setSelection([e.target.selectionStart, e.target.selectionEnd]);
                              }}
                              wrapperClassName={`fs-exclude ${addNewUserStyles.inputWrap}`}
                            />
                            <Box className={addNewUserStyles.inputWrap}>
                              <MUISelectInput
                                name="iState"
                                label="State"
                                value={getValues('iState') || ''}
                                onChange={(v: string) => setValue('iState', v, { shouldValidate: true })}
                                options={stateOptions}
                              />
                            </Box>
                            <MuiTextField
                              name="iZipCode"
                              label="Zip Code"
                              value={getValues('iZipCode')}
                              onChange={(e) => {
                                setValue('iZipCode', e.target.value, { shouldValidate: true });
                                setSelection([e.target.selectionStart, e.target.selectionEnd]);
                              }}
                              wrapperClassName={`fs-exclude ${addNewUserStyles.inputWrap}`}
                            />
                          </Box>
                        </div>
                      )}
                    {getValues('insurance_through') !== 'none' &&
                      getValues('insurance_through') !== '' &&
                      getValues('insurance_through') !== undefined && (
                        <div className={`${styles.row}`} style={{ flexDirection: 'row' }}>
                          <div className={`${styles.rowItem}`}>
                            <div className={styles.caption}>
                              Do you currently have insurance coverage through a state-funded program such as Medicaid?
                              <span> *</span>
                            </div>
                            <div className={styles.optionsDiv}>
                              {stateFundedProgramOptions.map((selection) => (
                                <button
                                  className={
                                    isSelected === selection.id
                                      ? `${styles.multiSelectorInsuranceCoverage} ${styles.buttonSelectedInsuranceCoverage}`
                                      : `${styles.multiSelectorInsuranceCoverage}`
                                  }
                                  value={getValues('state_funded_coverage_status')}
                                  {...register('state_funded_coverage_status')}
                                  type="button"
                                  onClick={() => {
                                    setIsSelected(selection.id);
                                    setValue('state_funded_coverage_status', selection.value, { shouldValidate: true });
                                  }}
                                  key={selection.id}
                                >
                                  <span>{selection.label}</span>
                                  <div className={styles.checkInput} />
                                </button>
                              ))}
                            </div>
                          </div>
                        </div>
                      )}
                    {getValues('insurance_through') !== 'none' &&
                      getValues('insurance_through') !== '' &&
                      getValues('insurance_through') !== undefined && (
                        <div className={`${styles.addSecondaryInsurance} form-check`}>
                          <input
                            className="form-check-input"
                            type="checkbox"
                            id="isAdditionalInsurance"
                            checked={addSecondaryInsurance}
                            onChange={(event) => {
                              setAddSecondaryInsurance(event.target.checked);
                            }}
                          />
                          <label
                            className={`form-check-label ${styles.additionalPeopleCheckLabel}`}
                            htmlFor="isAdditionalInsurance"
                          >
                            Add Secondary Insurance
                          </label>
                        </div>
                      )}
                    {addSecondaryInsurance &&
                      getValues('insurance_through') !== 'none' &&
                      getValues('insurance_through') !== undefined && (
                        <SecondaryInsuranceFields
                          register={register}
                          errors={errors}
                          getValues={getValues}
                          onChange={onChange}
                        />
                      )}
                  </div>
                </div>
              </>
            )}

            {(() => {
              const isCollectorCc =
                (userInfo.role.name === UserRoleName.Collector || userInfo.role.name === UserRoleName.CareAdvisor) &&
                isFromSelectPatient;

              if (isAdminReview) {
                return (
                  <div className={addNewUserStyles.actions}>
                    <MuiButton
                      type="submit"
                      variant="contained"
                      disabled={
                        (!externalAvatarAction &&
                          isEqual(dependentProfileForm, getValues()) &&
                          isEqual(avatarAction, '')) ||
                        isSavingProfile ||
                        fetchLoading
                      }
                      className={addNewUserStyles.saveChangesButton}
                    >
                      {isSavingProfile ? 'Saving…' : 'Save changes'}
                    </MuiButton>
                  </div>
                );
              }

              return (
                <div className={`${styles.actionBtnContainer} ${isCollectorCc ? styles.collectorCcActionRow : ''}`}>
                  <Button
                    type="button"
                    className={isCollectorCc ? styles.collectorCcBackLink : styles.cancel}
                    onClick={onCancelEditDependent}
                  >
                    {isCollectorCc ? (
                      <>
                        <MdKeyboardArrowLeft /> Back
                      </>
                    ) : (
                      'Cancel'
                    )}
                  </Button>
                  <Button
                    type="submit"
                    className={isCollectorCc ? styles.collectorCcNextBtn : styles.submit}
                    disabled={
                      (!externalAvatarAction &&
                        isEqual(dependentProfileForm, getValues()) &&
                        isEqual(avatarAction, '')) ||
                      isSavingProfile ||
                      fetchLoading
                    }
                  >
                    {isCollectorCc
                      ? 'Next'
                      : isFromSelectPatient && !isEditInsuranceFlag
                      ? 'Continue'
                      : isFromSelectPatient && isEditInsuranceFlag && !isEqual(dependentProfileForm, getValues())
                      ? (values.find((item) => item.form_question_id === 20)?.value.caseType as string) ===
                          CaseType.care_coordination && isFree(currentOrganizationPrices)
                        ? 'Save'
                        : 'Continue'
                      : 'Save'}
                  </Button>
                </div>
              );
            })()}
          </form>
          {dependentId !== undefined &&
            dependentId !== null &&
            dependentId !== 0 &&
            dependentId.toString() !== '' &&
            !isAdminReview &&
            [
              UserRoleName.Patient,
              UserRoleName.Admin,
              UserRoleName.SuperAdmin,
              UserRoleName.OrganizationAdmin,
            ].includes(userInfo.role.name) && (
              <>
                {!isFromSelectPatient || (isEditInsuranceFlag && <div className={styles.separator} />)}
                <div className={styles.row}>
                  <div className={styles.rowItem}>
                    {isEditInsurance || (isFromSelectPatient && isEditInsuranceFlag) ? (
                      <EditInsurance
                        myProfileForm={dependentProfileForm}
                        patientInsurance={patientInsurance!}
                        setPatientInsurance={setPatientInsurance}
                        setIsEditInsurance={setIsEditInsurance}
                        setSelection={setSelection}
                        loading={false}
                        thisUser={selectedPatient as UserProfile}
                        dependentId={dependentId}
                      />
                    ) : !isFromSelectPatient || isEditInsuranceFlag ? (
                      <ReadOnlyInsurance
                        onEditInsurance={() => {
                          setIsEditInsurance(true);
                        }}
                        patientInsurance={patientInsurance!}
                      />
                    ) : null}
                  </div>
                </div>
              </>
            )}
        </div>
      </div>
      <ConfirmationModal
        title="Confirmation"
        content="Are you sure you want to delete dependent?"
        isOpen={showDeleteDependentConfirmationModal || false}
        onClose={onCloseConfirmationModal}
        onConfirm={onContinueConfirmationModal}
        isSubmitDisabled={isSavingProfile}
      />
    </>
  );
};

EditDependent.defaultProps = {
  dependentId: '',
  isModal: false,
  reviewProfile: false,
  showDeleteDependentConfirmationModal: false,
  setShowDeleteDependentConfirmationModal: () => {},
};

export default EditDependent;
